// extracted by mini-css-extract-plugin
module.exports = {"root":"LabeledBox_root__3ogPV","label":"LabeledBox_label__2dkfF"};